<div id="home-problematic-spots">
  @if (hasAnyPremiumForSpotDetection) {
    <div class="header">
      <span class="title">{{ 'doktar_app.home.problematic_spots' | translate }}</span>
      <span class="description">{{ 'doktar_app.home.problematic_spot_description' | translate }}</span>
    </div>
    @if (!problematicSpotsLoading) {
      @if (!fetchingError) {
        @if (singlePlantationSpot) {
          <div class="body single-spot" (click)="goToCropMonitoring(singlePlantationSpot.plantationId)">
            <div
              class="spot-image"
              [dkSafeImage]="singlePlantationSpot.plantationImage"
              fallbackImage="/assets/images/lp/land-plantation-thumbnail-base.png"
              backgroundStyle="lightgray 50% 100% / cover no-repeat"
              [showSpinner]="true"></div>
            <div class="single-spot-footer">
              <div class="plantation-info">
                @if (singlePlantationLandName) {
                  <span class="land-name">{{ singlePlantationLandName }}</span>
                }
                <div class="content">
                  <span class="dot" [style.color]="singlePlantationSpot.cropColor">{{ '•' }}</span>
                  <span class="title">{{ singlePlantationSpot.plantationName }}</span>
                </div>
                <span class="description">
                  {{
                    'doktar_app.land_plantations_modal.xxx_area_planted'
                      | translate: { arg1: singlePlantationSpot.totalAreaDisplay }
                  }}
                </span>
              </div>
              <div class="warning">
                <span class="title">{{ 'doktar_app.common.warning' | translate }}</span>
                <div class="spot-counter">
                  <i class="ph-fill ph-warning-circle"></i>
                  <span>
                    {{
                      singlePlantationSpot.problematicSpotList.length > 1
                        ? ('doktar_app.home.n_prob_spots'
                          | translate: { arg1: singlePlantationSpot.problematicSpotList.length })
                        : ('doktar_app.home.n_prob_spot'
                          | translate: { arg1: singlePlantationSpot.problematicSpotList.length })
                    }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        } @else {
          <div class="body spot-list">
            @if (problematicSpots?.length > 0) {
              @for (spot of problematicSpots; track $index) {
                <div class="spot-item">
                  <div class="plantation-card" (click)="goToCropMonitoring(spot.plantationId)">
                    <div class="card-content">
                      <div class="plantation-placeholder">
                        <div
                          class="card-image"
                          [dkSafeImage]="spot?.plantationImage"
                          fallbackImage="/assets/images/lp/land-plantation-thumbnail-base.png"
                          backgroundStyle="lightgray 50% / cover no-repeat"
                          [showSpinner]="true"></div>
                      </div>
                      <div class="plantation-info">
                        <div class="content">
                          <span class="dot" [style.color]="spot.cropColor">{{ '•' }}</span>
                          <span class="title">{{ spot.plantationName }}</span>
                        </div>
                        <div class="details">
                          <span class="description">
                            {{ spot?.totalAreaDisplay }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="warning">
                    <span class="title">{{ 'doktar_app.common.warning' | translate }}</span>
                    <div class="spot-counter">
                      <i class="ph-fill ph-warning-circle"></i>
                      <span>
                        {{
                          spot.problematicSpotList.length > 1
                            ? ('doktar_app.home.n_prob_spots' | translate: { arg1: spot.problematicSpotList.length })
                            : ('doktar_app.home.n_prob_spot' | translate: { arg1: spot.problematicSpotList.length })
                        }}
                      </span>
                    </div>
                  </div>
                </div>
              }
            } @else {
              <div class="no-data">
                <div class="content">
                  <i class="ph-fill ph-gps-fix icon"></i>
                  <p class="title">{{ 'doktar_app.home.no_spot_message_title' | translate }}</p>
                  <p class="description">
                    {{ 'doktar_app.home.no_spot_message_description' | translate }}
                  </p>
                </div>
              </div>
            }
          </div>
        }
      } @else {
        <div class="body spots-error">
          <widget-info-box
            [isErrorState]="true"
            [title]="'doktar_app.home.warnings.not_load_problematic_spots_title' | translate"
            [description]="
              'doktar_app.home.warnings.not_load_problematic_spots_description'
                | translate
            "
            (primaryButtonClick)="getProblematicSpots()"></widget-info-box>
        </div>
      }
    } @else {
      <div class="body spots-loading">
        <p-skeleton width="100%" height="4rem" styleClass="mb-3" />
        <p-skeleton width="100%" height="4rem" styleClass="mb-3" />
        <p-skeleton width="100%" height="4rem" />
      </div>
    }
  } @else {
    <div class="body problematic-spots-no-premium">
      <div class="no-premium-spot card-image">
        <img src="/assets/images/no-premium/problematic-spot.png" alt="" />
      </div>
      <div class="content">
        <span class="title">{{ 'doktar_app.home.prob_spot_purchase_title' | translate }}</span>
        <span class="description">{{ 'doktar_app.home.prob_spot_purchase_description' | translate }}</span>
      </div>
      <div class="actions">
        <dk-button
          [label]="'doktar_app.common.get_premium' | translate"
          severity="primary"
          (onClick)="getPremiumEvent.emit()"></dk-button>
      </div>
    </div>
  }
</div>
